import {DomainObject, oneOf} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import Employee from 'main/stores/employees/Employee';

class BenefitEnrolmentSummary extends DomainObject {
  externalId;
  enrolmentStatus;
  benefitClassName;
  benefitDivisionName;
  healthCoverage;
  dentalCoverage;
  coverage;
  effectiveDate;
  firstEffectiveDate;
  probation;
  probationTimePeriod;
  lastDayOfBenefits;
  terminated;
  canEnrol;
  canUnenrol;
  canEditEnrolment;
  endDate;
  companyInsuranceCarrierId;

  _relations = {
    employee: Employee,
    probationTimePeriod: oneOf(['days', 'months']),
    _dates: ['effectiveDate', 'firstEffectiveDate', 'lastDayOfBenefits', 'endDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      externalId: observable,
      enrolmentStatus: observable,
      benefitClassName: observable,
      benefitDivisionName: observable,
      healthCoverage: observable,
      dentalCoverage: observable,
      coverage: observable,
      effectiveDate: observable,
      firstEffectiveDate: observable,
      probation: observable,
      probationTimePeriod: observable,
      lastDayOfBenefits: observable,
      terminated: observable,
      canEnrol: observable,
      canUnenrol: observable,
      canEditEnrolment: observable,
      endDate: observable,
      companyInsuranceCarrierId: observable
    });

    this.merge(other);
  }
}

export default BenefitEnrolmentSummary;
